var N = /* @__PURE__ */ ((n) => (n.TEXT = "text", n.OPTIONS = "options", n.TIME_RANGE = "time_range", n))(N || {}), I = /* @__PURE__ */ ((n) => (n.IN = "in", n.NOT_IN = "not_in", n))(I || {});
export {
  N as FilterType,
  I as TextFilterOperator
};
